import { render, staticRenderFns } from "./LanguageDropdown.vue?vue&type=template&id=7d4ca7c2&scoped=true&"
import script from "./LanguageDropdown.vue?vue&type=script&lang=ts&"
export * from "./LanguageDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageDropdown.vue?vue&type=style&index=0&id=7d4ca7c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4ca7c2",
  null
  
)

export default component.exports